var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSecurity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 27,
    r: 27,
    fill: "#EACB30",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1428 27.4215L23.2928 25.5715L22.2856 26.5786L25.1428 29.4358L30.8571 23.7215L29.8499 22.7143L25.1428 27.4215Z",
    fill: "#EACB30"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5714 37L22.16 34.6479C20.9024 33.9788 19.8507 32.9799 19.1178 31.7584C18.3849 30.5368 17.9985 29.1388 18 27.7143V18.4286C18.0004 18.0498 18.151 17.6867 18.4188 17.4188C18.6867 17.151 19.0498 17.0004 19.4286 17H33.7143C34.0931 17.0004 34.4562 17.151 34.724 17.4188C34.9919 17.6867 35.1425 18.0498 35.1429 18.4286V27.7143C35.1444 29.1388 34.758 30.5368 34.0251 31.7584C33.2922 32.9799 32.2405 33.9788 30.9829 34.6479L26.5714 37ZM19.4286 18.4286V27.7143C19.4274 28.8799 19.7436 30.0238 20.3434 31.0232C20.9432 32.0226 21.8038 32.8398 22.8329 33.3871L26.5714 35.3807L30.31 33.3879C31.3392 32.8405 32.1999 32.0232 32.7996 31.0236C33.3994 30.024 33.7156 28.88 33.7143 27.7143V18.4286H19.4286Z",
    fill: "#EACB30"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.5006b5e7a99c0393f25d95363c332bef.svg";
export { ForwardRef as ReactComponent };